import { api } from "../client";
import {
  DocumentOrderExtraFields,
  DocumentOrderFields,
  PartialDocumentOrderExtraFields,
  PartialDocumentOrderFields,
} from "../schema/DocumentOrder";
import { Config, ConfigMutate } from "../types";

type ApiRequestConfig = Config<DocumentOrderFields, DocumentOrderExtraFields>;
type ApiRequestConfigMutate = ConfigMutate<
  PartialDocumentOrderFields,
  PartialDocumentOrderExtraFields
>;

export const getDocumentOrders = async (config?: ApiRequestConfig) => {
  return api.get<DocumentOrderFields, DocumentOrderExtraFields>(
    "document_orders",
    config
  );
};
export const getDocumentOrder = (id: number, config?: ApiRequestConfig) => {
  return api.get<DocumentOrderFields, DocumentOrderExtraFields>(
    `document_orders/${id}`,
    config
  );
};

export const createDocumentOrder = (config: ApiRequestConfigMutate) => {
  return api.create<
    PartialDocumentOrderFields,
    PartialDocumentOrderExtraFields
  >("document_orders", config);
};
export const updateDocumentOrder = (
  id: number,
  config?: ApiRequestConfigMutate
) => {
  return api.update<
    PartialDocumentOrderFields,
    PartialDocumentOrderExtraFields
  >(`document_orders/${id}`, config);
};
export const deleteDocumentOrder = (id: number) => {
  return api.remove<DocumentOrderFields, DocumentOrderExtraFields>(
    `document_orders/${id}`
  );
};
